import React from "react";
import SoundPlayer from "../components/SoundPlayer";

/**
 * Page dédiée au lecteur de sons pour OBS
 * 
 * Cette page est conçue pour être utilisée comme source navigateur dans OBS.
 * Elle affiche une interface minimale et transparente qui joue les sons
 * associés aux commandes personnalisées.
 * 
 * URL: /sound-player
 */
export default function SoundPlayerPage() {
  return <SoundPlayer standalone={true} />;
}
